import { useEffect, useState } from "react";
import { DatePicker, Select, Button, message, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../redux/ReconAndSettlement/actions";
import "./index.scss";
import moment from "moment";

const { Option } = Select;
const { RangePicker } = DatePicker;
const { getReversalData, getReconDataReset } = actions;

const Filter = ({ selectedFile, setSelectedFile, loading }) => {
  const dispatch = useDispatch();
  const [messageApi, contextHolder] = message.useMessage();
  const [dropdown1Value, setDropdown1Value] = useState(null);
  const [dateRange, setDateRange] = useState({ fromDate: "", toDate: "" });

  const { fetchReconData } = useSelector((state) => ({
    fetchReconData: state.reconReducer?.fetchReconData,
  }));

  const handleDropdown1Change = (value) => setDropdown1Value(value);

  const handleDateChange = (dates) => {
    // console.log(dates , "dates");
    if (dates && dates.length === 2) {
      setDateRange({ fromDate: dates[0], toDate: dates[1] });
    } else {
      setDateRange([]);
    }
  };

  const handleFormSubmit = () => {
    if (dropdown1Value && dateRange.fromDate && dateRange.toDate) {
      const formattedStartDate = moment(dateRange?.fromDate["$d"]).format(
        "YYYY-MM-DDTHH:mm:ss%2B05:30"
      );
      const formattedEndDate = moment(dateRange?.toDate["$d"]).format(
        "YYYY-MM-DDTHH:mm:ss%2B05:30"
      );

      const fileData = {
        fileType: dropdown1Value,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      };

      setSelectedFile(fileData);

      dispatch(getReversalData(fileData));
    } else {
      message.warning("Please fill in all fields.");
    }
  };

  useEffect(() => {
    if (fetchReconData?.loading === true && fetchReconData?.error === null) {
      messageApi.destroy();
    } else if (
      fetchReconData?.error !== null &&
      !fetchReconData?.data?.message?.length > 0 &&
      fetchReconData?.loading === false
    ) {
      messageApi.destroy();
      messageApi
        .open({ type: "error", content: fetchReconData?.error, duration: 1 })
        .then(() => dispatch(getReconDataReset()));
    } else if (
      fetchReconData?.data?.message?.length > 0 &&
      fetchReconData?.error === null &&
      fetchReconData?.loading === false &&
      fetchReconData?.notified === false
    ) {
      messageApi.destroy();
      // messageApi
      //   .open({
      //     type: fetchReconData?.data?.url?.length > 0 ? "success" : "info",
      //     content: fetchReconData?.data?.message,
      //     duration: 1,
      //   })
      //   .then(() => dispatch(getReconDataNotified()));
    }
  }, [fetchReconData]);

  return (
    <div className="filter-container">
      {contextHolder}

      {/* {showForm ? ( */}
      <div className="form-container">
        <Select
          placeholder="Select File Type"
          className="filter-select"
          onChange={handleDropdown1Change}
        >
          <Option value="reversal">Reversal Mannual</Option>
          <Option value="reversal-automated">Reversal Automated</Option>
        </Select>

        <RangePicker
          className="filter-date-picker"
          showTime
          onChange={handleDateChange}
          placeholder={["Start Date", "End Date"]}
        />

        <Button onClick={handleFormSubmit} className="filter-button">
          {loading ? <Spin size="20" /> : "Submit"}
        </Button>
      </div>
    </div>
  );
};

export default Filter;
